import ScrollTrigger from '@terwanerik/scrolltrigger'

const trigger = new ScrollTrigger()

export default trigger